import React from "react";
import styled from "styled-components";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Joi from "joi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AnimatedPage from "../AnimatedPage";
import "animate.css/animate.min.css";
import { error } from "jquery";

function Bokning() {
  const [isMobile, setIsMobile] = useState("");
  const [timer, setTimer] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);
  const [hideAbout, setHideAbout] = useState(false);

  useEffect(() => {
    if (isFlipped) {
      document.body.style.overflow = "hidden";
      const timer = setTimeout(() => {
        setHideAbout(true);
        document.body.style.overflow = "";
      }, 2000);

      return () => {
        clearTimeout(timer);
        document.body.style.overflow = "";
      };
    }
  }, [isFlipped]);

  const [formDataError, setFormDataError] = useState({
    förnamn: "",
    efternamn: "",
    epost: "",
    adress: "",
    telefon: "",
    datum: "",
    tidFrån: "",
    tidTill: "",
    text: " ",
  });

  useEffect(() => {
    if (isFlipped) {
      const timer = setTimeout(() => {
        setHideAbout(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isFlipped]);

  const schema = Joi.object({
    förnamn: Joi.string().required().min(2).max(20).messages({
      "string.base": `Förnamn Måste bestå av 'bokstäver'`,
      "string.empty": `Förnamn får ej vara tomt`,
      "string.min": `Förnamn Måste vara minst {#limit} långt`,
      "string.max": `Förnamn Får max vara {#limit} karaktärer långt`,
      "any.required": `Förnamn måste vara ifyllt`,
    }),
    efternamn: Joi.string().min(2).max(20).messages({
      "string.base": `Efternamn Måste bestå av 'bokstäver'`,
      "string.empty": `Efternamn får ej vara tomt`,
      "string.min": `Efternamn Måste vara minst {#limit} långt`,
      "string.max": `Efternamn Får max vara {#limit} karaktärer långt`,
      "any.required": `Efternamn måste vara ifyllt`,
    }),
    epost: Joi.string()
      .email({ tlds: { allow: false } })
      .messages({
        "string.email": `E-post Måste vara en giltig e-post`,
        "string.empty": `E-post får ej vara tomt`,
        "any.required": `E-post måste vara ifyllt`,
      }),
    adress: Joi.string().min(2).max(20).messages({
      "string.empty": `Adress får ej vara tomt`,
      "string.min": `Adress Måste vara minst {#limit} långt`,
      "string.max": `Adress Får max vara {#limit} karaktärer långt`,
      "any.required": `Adress måste vara ifyllt`,
    }),
    telefon: Joi.string()
      .min(9)
      .max(10)
      .pattern(/^[0-9]+$/)
      .required()
      .messages({
        "string.empty": `Telefonnummer får ej vara tomt`,
        "string.min": `Telefonnummer Måste vara minst {#limit} långt`,
        "string.max": `Telefonnummer Får max vara {#limit} siffror långt`,
        "any.required": `Telefonnummer måste vara ifyllt`,
        "string.pattern.base": "Telefonnummer Måste bestå av siffror",
      }),
    datum: Joi.string().required().min(9).messages({
      "string.empty": `Telefonnummer får ej vara tomt`,
      "string.min": `Telefonnummer Måste vara minst {#limit} långt`,
      "string.max": `Telefonnummer Får max vara {#limit} siffror långt`,
      "any.required": `Telefonnummer måste vara ifyllt`,
      "string.pattern.base": "Telefonnummer Måste bestå av siffror",
    }),
    tidFrån: Joi.allow().messages({
      "string.empty": `Förnamn får ej vara tomt`,
      "any.required": `Förnamn måste vara ifyllt`,
    }),
    tidTill: Joi.allow(),
    text: Joi.string().allow(),
  });

  function validate() {
    const options = { abortEarly: false };
    const { error } = schema.validate(formData, options);
    if (!error) return null;
    const errors = {};
    for (const detail of error.details)
      errors[detail.context.key] = detail.message;
    return errors;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    formData[name] = value;
    setFormData({ ...formData });
    const errors = validate();
    formDataError[name] = errors[name];
    setFormDataError({ ...errors });
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (
      formDataError["förnamn"] != undefined &&
      formDataError["förnamn"] != ""
    ) {
      toast.warn(formDataError["förnamn"], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (
      formDataError["efternamn"] != undefined &&
      formDataError["efternamn"] != ""
    ) {
      toast.warn(formDataError["efternamn"], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (formDataError["epost"] != undefined && formDataError["epost"] != "") {
      toast.warn(formDataError["epost"], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (formDataError["adress"] != undefined && formDataError["adress"] != "") {
      toast.warn(formDataError["adress"], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (
      formDataError["telefon"] != undefined &&
      formDataError["telefon"] != ""
    ) {
      toast.warn(formDataError["telefon"], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (formDataError["datum"] != undefined && formDataError["datum"] != "") {
      toast.warn(formDataError["datum"], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (
      formDataError["tidFrån"] != undefined &&
      formDataError["tidFrån"] != ""
    ) {
      toast.warn(formDataError["tidFrån"], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (
      formDataError["förnamn"] == undefined &&
      formDataError["efternamn"] == undefined &&
      formDataError["epost"] == undefined &&
      formDataError["adress"] == undefined &&
      formDataError["telefon"] == undefined &&
      formDataError["datum"] == undefined &&
      formDataError["tidFrån"] == undefined
    ) {
      try {
        const order = await axios.post(
          "https://ellinornielsen-backend.onrender.com/api/bokning",
          {
            förnamn: formData.förnamn,
            efternamn: formData.efternamn,
            epost: formData.epost,
            adress: formData.adress,
            telefon: formData.telefon,
            datum: formData.datum,
            tidFrån: formData.tidFrån,
            tidTill: formData.tidTill,
            text: formData.text ? formData.text : " ",
          }
        );
        if (order)
          return (
            alert("Tack för din förfrågan, jag kontakatar er inom kort!"),
            (window.location.href = "/")
          );
      } catch (error) {
        console.log(error);
      }
    }
  }

  function closeMenu() {}

  const [formData, setFormData] = useState({
    förnamn: "",
    efternamn: "",
    epost: "",
    adress: "",
    telefon: "",
    datum: "",
    tidFrån: "",
    tidTill: "",
    text: "",
  });

  const history = useNavigate();

  let element = document.querySelector(".bosse");

  if (element) {
    element.remove();
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    handleResize();
    handleTimer();
  }, []);

  function handleTimer() {
    const interval = setInterval(() => {
      return setTimer(true);
    }, 2100);
  }

  function handleResize() {
    if (window.screen.width < 1200) {
      return setIsMobile(true);
    } else {
      return setIsMobile(false);
    }
  }

  return (
    <Total>
      <Container style={{maxWidth: isMobile ? "700px" : "1500px"}}>
        {!isMobile && (
          <Social>
            <div className="content">
              <Link to="/om" className="link">
                <div className="card">
                  <div className="icon"></div>
                  <p className="title">Om mig</p>
                  <p className="text"></p>
                </div>
              </Link>

              <Link to="/spelningar" className="link">
                <div className="card">
                  <div className="icon"></div>
                  <p className="title">Lyssna</p>
                  <p className="text"></p>
                </div>
              </Link>
            </div>
          </Social>
        )}
        {isMobile && (
          <MobileMenu>
            <Social>
              <div className="content">
                <Link to="/om" className="link">
                  <div className="card">
                    <div className="icon"></div>
                    <p className="title">Om mig</p>
                    <p className="text"></p>
                  </div>
                </Link>

                <Link to="/spelningar" className="link">
                  <div className="card">
                    <div className="icon"></div>
                    <p className="title">Lyssna</p>
                    <p className="text"></p>
                  </div>
                </Link>
              </div>
            </Social>
          </MobileMenu>
        )}
        <div className="flip-container">
          <div className={`flipper ${isFlipped ? "flipped" : ""}`}>
            <div className="front">
              {!hideAbout && (
                <StyledAbout>
                  <div className="around">
                    <h1 className="h1-first">
                      Vad roligt att du vill boka mig. Jag ska förklara{" "}
                      <br></br> lite närmare hur en bokning går till.
                    </h1>
                    <p className="p-first">
                      Fyll i formuläret vilken typ av tillställning det är och
                      vilka önskemål du har för <br></br> att jag ska få en så
                      bra uppfattning som möjligt.<br></br> <br></br> Om jag är
                      tillgänglig ert datum kommer jag preliminärboka dagen till
                      er<br></br> direkt utan kostnad. <br></br> <br></br> När
                      jag har fått er bokning kommer jag kontakta er för och
                      erbjuda er ett pris.<br></br> När ni godkänt priset kommer
                      jag skicka en bokningsbekräftelse. När giget är <br></br>
                      genomfört skickar jag en faktura för uppdraget.
                      <br></br>
                    </p>

                    <h1 className="h1-second">Vad kostar det?</h1>
                    <p className="p-second">
                      Varje uppdrag är unikt och kräver olika mycket
                      förberedelser, reptid och <br></br>resekostnader. Jag
                      sätter därför ett pris för varje uppdrag jag får.{" "}
                      <br></br> <br></br>Jag övar in specifika låtar och
                      anpassar underhållningen efter era önskemål. <br></br>
                      Mitt mål är att göra ett så bra uppdrag som möjligt
                      utifrån era önskemål.
                    </p>
                  </div>
                  <div
                    className="boka-button"
                    onClick={() => setIsFlipped(true)}
                  >
                    <span>Boka</span>
                    <img src="right-arrow.png" alt="Right arrow" />
                  </div>
                </StyledAbout>
              )}
            </div>
            <div className="back">
              <StyledForm>
                <div className="around">
                  <form onSubmit={handleSubmit}>
                    <StyledInput
                      label={"förnamn"}
                      name={"förnamn"}
                      type={"förnamn"}
                      placeholder={"Förnamn"}
                      onChange={handleChange}
                      value={formData.förnamn}
                    />
                    <StyledInput
                      label={"efternamn"}
                      name={"efternamn"}
                      type={"efternamn"}
                      placeholder={"Efternamn"}
                      onChange={handleChange}
                      value={formData.efternamn}
                    />

                    <StyledInput
                      label={"epost"}
                      name={"epost"}
                      type={"epost"}
                      placeholder={"Epost"}
                      onChange={handleChange}
                      value={formData.epost}
                    />
                    <StyledInput
                      label={"telefon"}
                      name={"telefon"}
                      type={"telefon"}
                      placeholder={"Telefon"}
                      onChange={handleChange}
                      value={formData.telefon}
                    />
                    <StyledInput
                      label={"adress"}
                      name={"adress"}
                      type={"adress"}
                      placeholder={"Adress"}
                      onChange={handleChange}
                      value={formData.adress}
                    />

                    <StyledInput
                      label={"datum"}
                      name={"datum"}
                      type={"text"}
                      placeholder={"Dag"}
                      onChange={handleChange}
                      value={formData.date}
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => (e.target.type = "text")}
                      style={{fontSize: isMobile ? "25px" : ""}}
                    />

                    <StyledInput
                      label={"tidFrån"}
                      name={"tidFrån"}
                      type={"input"}
                      placeholder={"Tid"}
                      onChange={handleChange}
                      value={formData.tidFrån}
                    />
                    <StyledSelect
                      name="tidTill"
                      onChange={handleChange}
                      value={formData.tidTill}
                    >
                      <option defaultValue="none">Typ av uppdrag</option>
                      <option value="Bröllop">Bröllop</option>
                      <option value="Bröllop med mingel">
                        Bröllop med mingel
                      </option>
                      <option value="Begravning">Begravning</option>
                      <option value="Dop">Dop</option>
                      <option value="företagsmingel">Företagsmingel</option>
                      <option value="fest">Fest</option>
                      <option value="Annat">Annat</option>
                    </StyledSelect>

                    <StyledText
                      className="textwrite"
                      label={"text"}
                      name={"text"}
                      type={"text area"}
                      placeholder={
                        "Här kan ni beskriva mer detaljerat vad bokningen avser, samt eventuella önskemål..."
                      }
                      onChange={handleChange}
                      value={formData.text}
                    />
                    <button className="skicka" onClick={() => onsubmit}>
                      Skicka
                    </button>
                  </form>
                </div>
              </StyledForm>
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {/* Same as */}
        <ToastContainer />
      </Container>
    </Total>
  );
}

export default Bokning;

const Total = styled.div`
  .brollopText {
    position: absolute;
    color: black;
    margin-left: 42.5vw;
    font-size: 120px;
    margin-top: 0vh;
    opacity: 0.2;
    font-style: oblique 2deg;
    font-family: Merriweather-Italic;
    font-weight: 100;
    @media screen and (max-width: 1200px) {
      margin-top: 32%;
      margin-left: 25%;
      font-size: 180px;
      opacity: 0.8;
    }
  }
  .dopText {
    position: absolute;
    color: black;
    margin-left: 47.8vw;
    font-size: 120px;
    margin-top: 0vh;
    opacity: 0.2;
    font-style: oblique 2deg;
    font-family: Merriweather-Italic;
    font-weight: 100;
    @media screen and (max-width: 1200px) {
      margin-top: 32%;
      margin-left: 35%;
      font-size: 180px;
      opacity: 0.8;
    }
  }
  .begravningText {
    color: black;
    position: absolute;
    margin-left: 34.7vw;
    font-size: 120px;
    margin-top: 0vh;
    opacity: 0.2;
    font-style: oblique 2deg;
    font-family: Merriweather-Italic;
    font-weight: 100;
    @media screen and (max-width: 1200px) {
      margin-top: 32%;
      margin-left: 13%;
      font-size: 150px;
      opacity: 0.8;
    }
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  max-width: 700px;

  .boka-button {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    padding: 10px;
    text-align: center;
    background-color: #815641;
    height: 40px;
    width: 40px;
    color: white;
    border-radius: 55%;
    cursor: pointer;
    position: absolute;
    right: -30px;
    top: 40%;

    @media screen and (max-width: 1000px) {
      right: -5px;
      top: 45%;
    }
  }

  .boka-button img {
    margin-top: 4px;
    width: 100%;
    max-width: 3ch;
    height: auto;
    filter: brightness(0%) invert(1);
    margin-top: -10px;
  }

  .flip-container {
    perspective: 1000px;
    width: 100%;
    height: 100%;
    position: relative;
  }

  .flipper {
    transition: 2s;
    transform-style: preserve-3d;
    position: relative;
  }

  .flipped {
    transform: rotateY(180deg);
  }

  .front,
  .back {
    backface-visibility: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .front {
    @media screen and (min-width: 1800px) {
      left: 17%;
    }
  }

  .back {
    transform: rotateY(180deg);
  }

  .around {
    background-color: tansparent;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 0 120px white;
    top: 50px;
    margin-left: -6%;

    @media screen and (max-width: 1000px) {
      margin-left: 30%;
      width: 700px;
    }
  }

  .skicka {
    height: 46px;
    width: 160px;
    border: none;
    border-radius: 23px;
    background-color: #815641;
    color: #f8f3ee;
    font-size: 17px;
    font-family: 'Cormorant Garamond', serif;
    letter-spacing: 0.12em;
    cursor: pointer;
    margin-top: 16px;
    margin-left: 0;
    box-shadow: 0 4px 18px rgba(129, 86, 65, 0.28);
    transition: background 0.3s, transform 0.2s, box-shadow 0.3s;
    display: block;

    @media screen and (max-width: 391px) {
      margin-left: 0;
    }
    :hover {
      background-color: #6a4535;
      transform: translateY(-2px);
      box-shadow: 0 6px 22px rgba(129, 86, 65, 0.38);
      height: 46px;
      width: 160px;
      font-size: 17px;

      @media screen and (max-width: 1000px) {
        height: 66px;
        width: 260px;
        font-size: 25px;
      }
    }
    :not(:hover) {
      transition: all 0.3s;
      height: 46px;
      width: 160px;
      font-size: 17px;
      @media screen and (max-width: 1000px) {
        height: 66px;
        width: 260px;
        font-size: 25px;
      }
    }
  }
  .first {
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    backdrop-filter: blur(19.5px);
    -webkit-backdrop-filter: blur(19.5px);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    opacity: 0.8;
    border-radius: 32px;
    padding: 20px;
    margin-top: 13%;
    width: 280px;
    top: 10%;
    left: 2%;
    position: absolute;
    font-family: helvetica;
    color: rgb(61, 53, 53);
    font-size: 22px;

    @media screen and (max-width: 1000px) {
      display: none;
    }
  }
  .second {
    padding: 20px;
    margin-left: 150px;
    margin-top: -200px;
    margin-bottom: -20px;

    position: absolute;
    font-family: helvetica;
    color: #656565;
  }
`;

const StyledInput = styled.input`
  height: 46px;
  width: 280px;
  margin: 8px 10px;
  border: none;
  border-bottom: 1.5px solid #c4a882;
  border-radius: 0;
  font-size: 15px;
  font-family: 'Jost', sans-serif;
  background: transparent;
  color: #120d09;
  padding: 0 6px;
  outline: none;
  box-shadow: none;
  transition: border-color 0.25s;

  &::placeholder {
    color: #b08060;
    font-style: italic;
    font-family: 'Cormorant Garamond', serif;
    font-size: 14px;
    letter-spacing: 0.04em;
     @media screen and (max-width: 1000px) {
      font-size: 25px;
    }
  }
  &:focus {
    border-bottom-color: #815641;
  }

  @media screen and (max-width: 1000px) {
    font-size: 18px;
    height: 58px;
    width: 260px;
    margin: 10px;
  }
`;
const StyledSelect = styled.select`
  height: 46px;
  width: 280px;
  margin: 8px 10px;
  border: none;
  border-bottom: 1.5px solid #c4a882;
  border-radius: 0;
  font-size: 14px;
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  background: transparent;
  color: #815641;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  box-shadow: none;
  letter-spacing: 0.04em;
  transition: border-color 0.25s;

  option {
    font-style: normal;
    color: #120d09;
    background: #f8f3ee;
    font-family: 'Jost', sans-serif;
  }
  &:focus {
    border-bottom-color: #815641;
  }

  @media screen and (max-width: 1000px) {
    font-size: 25px;
    height: 58px;
    width: 260px;
    margin: 10px;
  }
`;
const StyledText = styled.textarea`
  margin: 8px 10px;
  width: 588px;
  height: 110px;
  border: 1px solid #c4a882;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.55);
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  color: #120d09;
  padding: 12px 14px;
  resize: none;
  outline: none;
  box-shadow: none;
  transition: border-color 0.25s;

  &::placeholder {
    color: #b08060;
    font-style: italic;
    font-family: 'Cormorant Garamond', serif;
    font-size: 13px;
    @media screen and (max-width: 1000px) {
      font-size: 25px;
    }
  }
  &:focus {
    border-color: #815641;
  }

  @media screen and (max-width: 1000px) {
    font-size: 18px;
    height: 300px;
    width: 548px;
  }
`;

const Social = styled.div`
  @media screen and (max-width: 1000px) {
    z-index: 999;
  }
  z-index: 999;
  .link {
    text-decoration: none;
    position: relative;
    max-width: 200px;
    margin-left: 20px;
  }
  text-decoration: none;
  body {
    width: 100vw;
    background-color: #1d1d1d;
    margin: 0;
    font-family: helvetica;
  }

  .about {
    $cubic: cubic-bezier(0.64, 0.01, 0.07, 1.65);
    $transition: 0.6s $cubic;
    $size: 40px;
    position: fixed;
    z-index: 10;
    bottom: 10px;
    right: 10px;
    width: $size;
    height: $size;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    transition: all 0.2s ease;

    .bg_links {
      width: $size;
      height: $size;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(#fff, 0.2);
      border-radius: 100%;
      backdrop-filter: blur(5px);
      position: absolute;
    }

    .logo {
      width: $size;
      height: $size;
      z-index: 9;
      background-image: url(https://rafaelalucas91.github.io/assets/codepen/logo_white.svg);
      background-size: 50%;
      background-repeat: no-repeat;
      background-position: 10px 7px;
      opacity: 0.9;
      transition: all 1s 0.2s ease;
      bottom: 0;
      right: 0;
    }

    .social {
      opacity: 0;
      right: 0;
      bottom: 0;

      .icon {
        width: 100%;
        height: 100%;
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: transparent;
        display: flex;
        transition: all 0.2s ease, background-color 0.4s ease;
        opacity: 0;
        border-radius: 100%;
      }

      &.portfolio {
        transition: all 0.8s ease;

        .icon {
          background-image: url(https://rafaelalucas91.github.io/assets/codepen/link.svg);
        }
      }

      &.dribbble {
        transition: all 0.3s ease;
        .icon {
          background-image: url(https://rafaelalucas91.github.io/assets/codepen/dribbble.svg);
        }
      }

      &.linkedin {
        transition: all 0.8s ease;
        .icon {
          background-image: url(https://rafaelalucas91.github.io/assets/codepen/linkedin.svg);
        }
      }
    }

    &:hover {
      width: 105px;
      transition: all $transition;

      .logo {
        opacity: 1;
        transition: all 0.6s ease;
      }

      .social {
        opacity: 1;

        .icon {
          opacity: 0.9;
        }

        &:hover {
          background-size: 28px;
          .icon {
            background-size: 65%;
            opacity: 1;
          }
        }

        &.portfolio {
          right: 0;
          bottom: calc(100% - 40px);
          transition: all 0.3s 0s $cubic;

          .icon {
            &:hover {
              background-color: #698fb7;
            }
          }
        }

        &.dribbble {
          bottom: 45%;
          right: 45%;
          transition: all 0.3s 0.15s $cubic;
          .icon {
            &:hover {
              background-color: #ea4c89;
            }
          }
        }

        &.linkedin {
          bottom: 0;
          right: calc(100% - 40px);
          transition: all 0.3s 0.25s $cubic;
          .icon {
            &:hover {
              background-color: #0077b5;
            }
          }
        }
      }
    }
  }

  .wrapper {
    width: 100vw;
    margin: 0 auto;
    background-color: #161616;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all 0.3s ease;
  }

  @media screen and (max-width: 767px) {
    .wrapper {
      height: 700px;
    }
  }

  .content {
    width: 100vw;
    height: 30%;
    padding: 0 4%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    bottom: -5%;
    position: fixed;
    z-index: 999;

    @media screen and (max-width: 1000px) {
      left: -24%;
      height: 20%;
    }

    @media screen and (max-width: 1800px) {
      left: -5%;
    }
  }

  .card {
    width: 50%;
    max-width: 300px;
    min-width: 200px;
    height: 150px;
    background-color: #815641;
    margin: 10px;
    border-radius: 10px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
    border: 2px solid rgba(7, 7, 7, 0.12);
    font-size: 12px;
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .mic {
      margin-left: -200px;
      margin-top: -90px;
      height: 80px;
      width: 80px;
      position: relative;
    }

    cursor: pointer;
    transition: all 0.3s ease;
    :hover {
      margin-top: -120px;
    }
  }

  .icon {
  }

  .material-icons.md-18 {
    font-size: 12px;
  }
  .material-icons.md-24 {
    font-size: 12px;
  }
  .material-icons.md-36 {
    font-size: 28px;
  }
  .material-icons.md-48 {
    font-size: 48px;
  }

  .card .title {
    width: 100%;
    margin: 0;
    text-align: center;
    margin-top: -40px;
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 4px;
    font-size: 20px;
    font-family: helvetica !important;
  }

  .card .text {
    width: 80%;
    margin: 0 auto;
    font-size: 12px;
    text-align: center;
    margin-top: 20px;
    color: white;
    font-weight: 200;
    letter-spacing: 2px;
    opacity: 0;
    max-height: 0;
  }

  .card:hover {
    height: 270px;
  }

  .card:hover .info {
    height: 90%;
  }
  .card:hover .info {
    height: 90%;
  }

  .card:hover .text {
    opacity: 1;
    max-height: 40px;
    margin-top: 0px;
    font-size: 15px;
  }

  .card:hover .icon {
    background-position: -120px;
    margin-top: -40px;
    height: 150px;
  }

  .card:hover .title {
    margin-top: -200px;
    margin-bottom: 60px;
  }

  .card:hover .icon i {
    background: linear-gradient(90deg, #ff7e7e, #ff4848);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    opacity: 1;
  }
`;

const StyledForm = styled.div`
  position: relative;
  z-index: 1;
  margin-left: 29%;
  margin-top: -20%;
  max-width: 700px;

  @media screen and (min-width: 1800px) {
    top: 8%;
    margin-left: 47%;
  }
  @media screen and (max-width: 1000px) {
    margin-left: -18%;
    margin-top: 10%;
  }

  .around {
    background: rgba(248, 243, 238, 0.97);
    border-radius: 20px;
    box-shadow: 0 8px 48px rgba(129, 86, 65, 0.16);
    padding: 36px 28px 28px;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);

    &::before {
      content: 'Bokningsförfrågan';
      display: block;
      font-family: 'Cormorant Garamond', serif;
      font-size: 26px;
      font-weight: 400;
      color: #815641;
      letter-spacing: 0.12em;
      text-align: center;
      margin-bottom: 20px;

      @media screen and (max-width: 1000px) {
      font-size: 35px;
    }
    }

    @media screen and (max-width: 1000px) {
      width: 750px;
      height: 850px;
    }
  }

  form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
    gap: 4px;
  }

  .textwrite {
    grid-column: span 2;
  }
`;

const MobileMenu = styled.div`
  body {
    margin: 0;
    padding: 0;

    /* make it look decent enough */
    background: #232323;
    color: #cdcdcd;
    font-family: "Avenir Next", "Avenir", sans-serif;
  }

  #menuToggle {
    display: block;
    position: fixed;
    top: 350px;
    left: 50px;

    z-index: 1;

    -webkit-user-select: none;
    user-select: none;
  }

  #menuToggle a {
    text-decoration: none;
    color: #232323;

    transition: color 0.3s ease;
  }

  #menuToggle a:hover {
    color: tomato;
  }

  #menuToggle input {
    display: block;
    width: 120px;
    height: 102px;
    position: absolute;
    top: -7px;
    left: -22px;

    cursor: pointer;

    opacity: 0; /* hide this */
    z-index: 2; /* and place it over the hamburger */

    -webkit-touch-callout: none;
  }

  /*
 * Just a quick hamburger
 */
  #menuToggle span {
    display: block;
    width: 82px;
    height: 12px;
    margin-bottom: 15px;
    position: relative;

    background: #737373;
    border-radius: 3px;

    z-index: 1;

    transform-origin: 4px 0px;

    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
      background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
  }

  #menuToggle span:first-child {
    transform-origin: 0% 0%;
  }

  #menuToggle span:nth-last-child(2) {
    transform-origin: 0% 100%;
  }

  /* 
 * Transform all the slices of hamburger
 * into a crossmark.
 */
  #menuToggle input:checked ~ span {
    opacity: 1;
    transform: rotate(45deg) translate(1px, 1px);
    background: #232323;
  }

  /*
 * But let's hide the middle one.
 */
  #menuToggle input:checked ~ span:nth-last-child(3) {
    opacity: 0;
    transform: rotate(0deg) scale(0.2, 0.2);
  }

  /*
 * Ohyeah and the last one should go the other direction
 */
  #menuToggle input:checked ~ span:nth-last-child(2) {
    transform: rotate(-45deg) translate(0, -1px);
  }

  /*
 * Make this absolute positioned
 * at the top left of the screen
 */
  #menu {
    position: absolute;
    width: 180vw;
    height: 200vh;
    margin: -100px 0 0 -50px;
    padding: 50px;
    padding-top: 125px;

    background: #ededed;
    list-style-type: none;
    -webkit-font-smoothing: antialiased;
    /* to stop flickering of text in safari */

    transform-origin: 0% 0%;
    transform: translate(-100%, 0);

    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
  }

  #menu li {
    padding: 10px 0;
    font-size: 52px;
  }

  /*
 * And let's slide it in from the left
 */
  #menuToggle input:checked ~ ul {
    transform: none;
  }
`;

const StyledAbout = styled.div`
  height: 450px;
  width: 500px;
  color: black;
  margin-left: 36%;
  margin-top: -15%;
  z-index: 2;
  scale: calc(1.4);

  @media screen and (max-width: 1000px) {
    margin-left: 36%;
    margin-top: -10%;
  }

  .around {
    background: rgba(255, 255, 255, 0.59);
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(9.5px);
    -webkit-backdrop-filter: blur(9.5px);

    @media screen and (max-width: 1000px) {
      width: 350px;
    }
  }

  @media screen and (max-width: 1000px) {
    scale: calc(2);
    margin-top: 25%;
    height: 520px;
    width: 600px;
    margin-left: 3%;
  }

  .h1-first {
    margin-bottom: 10px;
    font-size: 19px;
  }

  .p-first {
    font-size: 12px;
    margin-bottom: 20px;
  }

  .h1-second {
    font-size: 15px;
  }

  .p-second {
    font-size: 12px;
  }
`;